module.exports = __webpack_public_path__ + "img/nike-full.764234cb.jpg";